import { render, staticRenderFns } from "./significantCompetitorMove.vue?vue&type=template&id=44dfff12"
import script from "./significantCompetitorMove.vue?vue&type=script&lang=js"
export * from "./significantCompetitorMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports